// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__qn4_K","requiredAsterisk":"Info_requiredAsterisk__20I80"};